import { Phone, MessageCircle, MapPin, Mail } from "lucide-react";
import { Button } from "../ui/button";
import { BRAND, WHATSAPP_URL, TEL_URL, MAPS_URL } from "../../lib/site-data";

export default function ContactSection() {
    return (
        <section className="relative py-24 md:py-32 border-b border-white/5" data-testid="contact-section">
            <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
                <div className="grid lg:grid-cols-12 gap-10">
                    <div className="lg:col-span-5 space-y-7">
                        <div>
                            <p className="text-xs uppercase tracking-[0.3em] text-cyan-300/80 mb-3">
                                İletişim
                            </p>
                            <h2 className="font-display text-3xl md:text-5xl text-white tracking-tight text-balance">
                                {BRAND.name}
                            </h2>
                            <p className="text-sm uppercase tracking-[0.25em] text-zinc-400 mt-2">
                                {BRAND.owner}
                            </p>
                        </div>

                        <div className="space-y-4 text-sm">
                            <a href={TEL_URL} className="flex items-start gap-3 text-zinc-300 hover:text-cyan-300" data-testid="contact-phone">
                                <Phone className="h-4 w-4 mt-0.5 text-cyan-300" />
                                <span>{BRAND.phone}</span>
                            </a>
                            <div className="flex items-start gap-3 text-zinc-300">
                                <MapPin className="h-4 w-4 mt-0.5 text-cyan-300 flex-shrink-0" />
                                <span className="leading-relaxed">{BRAND.address}</span>
                            </div>
                            <div className="flex items-start gap-3 text-zinc-300">
                                <Mail className="h-4 w-4 mt-0.5 text-cyan-300 flex-shrink-0" />
                                <span>info@istanbuldovmesilme.com</span>
                            </div>
                        </div>

                        <div className="grid grid-cols-2 gap-3 max-w-md">
                            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-testid="contact-whatsapp-btn">
                                <Button className="w-full bg-[#25D366] hover:bg-[#1ebe5a] text-white">
                                    <MessageCircle className="h-4 w-4 mr-2" />
                                    WhatsApp
                                </Button>
                            </a>
                            <a href={TEL_URL} data-testid="contact-call-btn">
                                <Button
                                    variant="outline"
                                    className="w-full bg-transparent border-white/15 text-white hover:bg-white/5"
                                >
                                    <Phone className="h-4 w-4 mr-2" />
                                    Hemen Ara
                                </Button>
                            </a>
                            <a href={MAPS_URL} target="_blank" rel="noopener noreferrer" data-testid="contact-maps-btn">
                                <Button
                                    variant="outline"
                                    className="w-full bg-transparent border-white/15 text-white hover:bg-white/5"
                                >
                                    <MapPin className="h-4 w-4 mr-2" />
                                    Yol Tarifi
                                </Button>
                            </a>
                            <a href="#lead-form" data-testid="contact-form-btn">
                                <Button className="w-full bg-cyan-400 text-black hover:bg-cyan-300">
                                    Ön Değerlendirme
                                </Button>
                            </a>
                        </div>
                    </div>

                    <div className="lg:col-span-7 rounded-2xl overflow-hidden border border-white/10 h-[400px] md:h-[500px] bg-[#0A0A0A]">
                        <iframe
                            title="Konum"
                            src={`https://www.google.com/maps?q=${encodeURIComponent(BRAND.mapsQuery)}&output=embed`}
                            className="w-full h-full grayscale-[40%] contrast-[1.1] opacity-90"
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        ></iframe>
                    </div>
                </div>
            </div>
        </section>
    );
}
